export default __webpack_public_path__ + "static/media/la_ferte-vidame11.26a231fc.jpg";